import React, { useRef, useEffect, useState } from 'react';
import { Button } from './Button';
import { useInViewAnimation } from '../hooks/useInViewAnimation';

const gifs = [
  "https://motionsites.ai/assets/hero-space-voyage-preview-eECLH3Yc.gif",
  "https://motionsites.ai/assets/hero-portfolio-cosmic-preview-BpvWJ3Nc.gif",
  "https://motionsites.ai/assets/hero-velorah-preview-CJNTtbpd.gif",
  "https://motionsites.ai/assets/hero-asme-preview-B_nGDnTP.gif",
  "https://motionsites.ai/assets/hero-transform-data-preview-Cx5OU29N.gif",
  "https://motionsites.ai/assets/hero-aethera-preview-DknSlcTa.gif",
  "https://motionsites.ai/assets/hero-orbit-web3-preview-BXt4OttD.gif",
  "https://motionsites.ai/assets/hero-nexora-preview-cx5HmUgo.gif"
];

export function PartnerSection() {
  const { ref, isInView } = useInViewAnimation();
  const containerRef = useRef(null);
  const [spawnedGifs, setSpawnedGifs] = useState([]);
  const lastSpawnTime = useRef(0);
  const gifIdCounter = useRef(0);
  const requestRef = useRef();

  const handleMouseMove = (e) => {
    const now = performance.now();
    if (now - lastSpawnTime.current > 80) {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const newGif = {
        id: gifIdCounter.current++,
        x,
        y,
        rotation: Math.random() * 20 - 10,
        url: gifs[Math.floor(Math.random() * gifs.length)],
        timestamp: now
      };

      setSpawnedGifs((prev) => [...prev, newGif]);
      lastSpawnTime.current = now;
    }
  };

  useEffect(() => {
    const cleanupLoop = (time) => {
      setSpawnedGifs((prev) => prev.filter((gif) => time - gif.timestamp < 1000));
      requestRef.current = requestAnimationFrame(cleanupLoop);
    };

    requestRef.current = requestAnimationFrame(cleanupLoop);

    return () => {
      if (requestRef.current) cancelAnimationFrame(requestRef.current);
    };
  }, []);

  return (
    <section ref={ref} className="w-full py-12 px-6 overflow-hidden">
      <div
        ref={containerRef}
        onMouseMove={handleMouseMove}
        className={`relative max-w-7xl mx-auto py-48 rounded-[40px] shadow-[0_20px_80px_rgba(76,29,149,0.25)] bg-gradient-to-br from-[#F6FCFF] via-white to-[#EDE9FE] flex flex-col items-center justify-center text-center overflow-hidden cursor-crosshair border border-[#7C3AED]/15 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
      >
        {/* violet ambient blobs */}
        <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-[#7C3AED]/25 blur-3xl pointer-events-none animate-pulse-glow" />
        <div className="absolute -bottom-40 -right-40 w-[520px] h-[520px] rounded-full bg-[#4C1D95]/20 blur-3xl pointer-events-none" />
        <div className="absolute inset-0 tech-grid opacity-30 pointer-events-none" />
        <div className="absolute inset-0 pointer-events-none overflow-hidden rounded-[40px] z-0">
          {spawnedGifs.map((gif) => {
            const age = performance.now() - gif.timestamp;
            const progress = Math.min(age / 1000, 1);
            const scale = 1 - progress * 0.5;
            const opacity = 1 - progress;

            return (
              <img
                key={gif.id}
                src={gif.url}
                alt=""
                className="absolute w-48 md:w-64 h-auto rounded-xl shadow-lg object-cover"
                style={{
                  left: gif.x,
                  top: gif.y,
                  transform: `translate(-50%, -50%) rotate(${gif.rotation}deg) scale(${scale})`,
                  opacity,
                  transition: 'none'
                }}
              />
            );
          })}
        </div>

        <div className="relative z-10 pointer-events-none">
          <h2 className="font-serif text-[44px] md:text-[60px] lg:text-[76px] grad-text mb-8 leading-[1.05]">
            Ready to Build Something<br />Extraordinary?
          </h2>

          <Button to="/contact" variant="primary" className="pointer-events-auto !pl-2 gap-3 !py-2">
            <span className="w-10 h-10 rounded-full bg-white flex items-center justify-center overflow-hidden">
              <img
                src="/yp-nova-logo.jpg"
                alt="YP Nova"
                className="w-8 h-8 object-contain"
              />
            </span>
            <span className="pr-5">Book a Discovery Call</span>
          </Button>
        </div>
      </div>
    </section>
  );
}
